<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Canteen Meal Report</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <br />
            <v-row justify="center" dense>
                <v-col cols="12" sm="4" md="4">
                    <v-combobox v-model="registration_no" rounded :items="stud_list" label="Select Student"
                        item-text="name" outlined dense prepend-icon="mdi-account-child-circle"></v-combobox>
                </v-col>
                <v-col cols="3">
                    <v-select rounded :items="aylist" label="Academic Year" item-text="academicyear" item-value="ay_id"
                        outlined dense v-model="ay"></v-select>
                </v-col>
                <v-btn class="mt-2 button" small @click="proceed();" :loading="loader">Proceed</v-btn>
            </v-row>
            <v-card class="box" v-if="learner_canteen_meal_history != ''">

                <v-btn rounded class="mr-2 pb-3 pt-2" color="success" outlined
                    @click="fnExcelReport('my-table-id', 'CanteenReportAdmin')" :loading="loader"><v-icon
                        color="success">mdi-export</v-icon>Export</v-btn>
                <div id="my-table-id">
                    <v-data-table v-if="learner_canteen_meal_history != ''" :headers="headers" :items="bookList1"
                        class="elevation-1 mytable" dense :search="search" @current-items="getFiltered">
                        <template v-slot:item.meal_count="{ item }">
                            <v-btn link @click="meal_history(item.meal_details)"> {{ item.meal_count }}</v-btn>
                        </template>
                        <template v-slot:top class="pb-5">
                            <v-toolbar flat>

                                <v-divider class="mx-4" inset vertical></v-divider>
                                <v-spacer></v-spacer>
                                <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                                    hide-details></v-text-field>
                            </v-toolbar>
                            <template>
                                <v-row dense justify="center" align="center">
                                    <tr class="t-row">
                                        <div>
                                            <th>
                                                <v-row dense>
                                                    <span v-for="header in headers" :key="header.text">
                                                        <span v-if="filters.hasOwnProperty(header.value)">
                                                            <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details
                                                                small rounded dense outlined color="#0F2027"
                                                                :label="header.text" multiple clearable
                                                                :items="columnValueList(header.value)"
                                                                v-model="filters[header.value]"></v-autocomplete>
                                                        </span>
                                                    </span>
                                                </v-row>
                                            </th>
                                        </div>
                                    </tr>
                                </v-row>
                            </template>
                        </template>
                    </v-data-table>
                </div>
            </v-card>
        </v-card>
        <v-dialog v-model="dialog_meal_details" max-width="800px">
            <v-card>
                <v-col cols="12" sm="12" md="12">
                    <v-card class="box">
                        <v-row justify="center" dense>
                            <v-col cols="12" sm="6" md="6">
                                <v-data-table v-if="meal_details != ''" :headers="headers_1" :items="meal_details"
                                    class="elevation-1 mytable" dense :search="search">
                                </v-data-table>
                            </v-col>
                        </v-row>
                        <v-row justify="center" dense>
                            <v-btn class="button" @click="dialog_meal_details = false">Close</v-btn>
                        </v-row>
                    </v-card>
                </v-col>
            </v-card>
        </v-dialog>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {

    data: () => ({

        loader: false,
        search: "",
        snackbar_msg: "",
        snackbar: false,
        color: "",
        registration_no: "",
        aylist: [],
        ay: "",
        overlay: false,
        stud_list: [],
        org_id: null,
        show_reason: false,
        learner_canteen_meal_history: [],
        filters: {
            name: [],

        },
        headers: [
            {
                text: "Sr. No.",
                align: "left",
                sortable: false,
                value: "sr_no",
            },
            {
                text: "Installment",
                align: "left",
                sortable: false,
                value: "name",
            },
            {
                text: "Meal Count",
                align: "left",
                sortable: false,
                value: "meal_count",
            },
        ],
        headers_1: [
            {
                text: "Sr. No.",
                align: "left",
                sortable: false,
                value: "srno",
            },
            {
                text: "Meal Date",
                align: "left",
                sortable: false,
                value: "date",
            },
        ],
        meal_details: [],
        dialog_meal_details: false
    }),
    computed: {
        bookList1() {
            return this.learner_canteen_meal_history.filter((d) => {
                return Object.keys(this.filters).every((f) => {
                    return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                });
            });
        },
    },
    methods: {
        fnExcelReport(id, name) {
            let tab_text = `<table border='1px'>
    <tr>
      <th>Sr.No</th>
      <th>Installment</th>
      <th>Meal Count</th>
      
      
    </tr>`;

            this.learner_canteen_meal_history.forEach((item, index) => {
                tab_text += `
    <tr>
        <td>${index + 1}</td> 
        <td>${item.name}</td>
        <td>${item.meal_count}</td>
       
    </tr>`;
            });

            tab_text += '</table>';

            const blob = new Blob([tab_text], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            const filename = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                // For IE
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                // For modern browsers
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
            }
        },
        getFiltered(e) {
            this.filterArr = e;
        },
        columnValueList(val) {
            return this.learner_canteen_meal_history.map((d) => d[val]);
        },

        ExportToExcel() {
            var htmltable = document.getElementById("my-table-id");
            var html = htmltable.outerHTML;
            window.open("data:application/vnd.ms-excel," + encodeURIComponent(html));
        },
        meal_history(meal_details) {
            this.meal_details = []
            this.meal_details = meal_details
            this.dialog_meal_details = true
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        async proceed() {
            if (this.registration_no == "") {
                this.showSnackbar("#b71c1c", "Please Enter Registration No");
                return;
            }
            if (this.ay == "" || this.ay == null) {
                this.showSnackbar("#b71c1c", "Please Select Academic Year");
                return;
            }
            const formData = {
                ay: this.ay,
                registration_no: this.registration_no.registration_number,
            };
            this.loader = true
            try {
                const res = await axios.post("/Canteen/getCanteenInstallmentMealReport", formData);
                if (res.data.flag == "YES") {
                    this.learner_canteen_meal_history = res.data.learner_canteen_meal_history
                    this.loader = false
                }
                if (res.data.flag == "NO") {
                    this.showSnackbar("red", res.data.fmsg); // show snackbar
                    this.loader = false
                }
            } catch (error) {
                this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                this.loader = false
            } finally {
                this.loader = false
            }
        },

        onload() {
            axios
                .post("FeesStructureInstallment/getdata")
                .then((res) => {
                    if (res.data.flag == "YES") {
                        (this.aylist = res.data.aylist), (this.ay = res.data.curreny_ay);
                        this.stud_list = res.data.stud_list;
                    } else {
                        this.showSnackbar("#b71c1c", res.data.status_reason);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                })
                .finally(() => { });
        },
    },
    mounted() {
        this.onload();
        this.org_id = localStorage.getItem("EPS-tenant");
        this.basepath = localStorage.getItem("awspath");
    },
};
</script>
<style scoped></style>
